import React, { SVGProps } from 'react'
const SvgTrashHover = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#EB505B'}
      d="M9.25 7.25V5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v2.25h3.75a.75.75 0 0 1 .14 1.487 1.764 1.764 0 0 1 .013.415l-.826 9.5a1.75 1.75 0 0 1-1.744 1.598H7.917a1.75 1.75 0 0 1-1.744-1.598l-.826-9.5a1.754 1.754 0 0 1 .013-.415.75.75 0 0 1 .14-1.487h3.75Zm1.5 0h2.5v-1.5h-2.5v1.5Zm-.302 9.444-.45-6a.75.75 0 0 0-1.496.112l.45 6a.75.75 0 0 0 1.496-.112Zm2.302.056v-6a.75.75 0 1 0-1.5 0v6a.75.75 0 1 0 1.5 0Zm2.298.056.45-6a.75.75 0 0 0-1.496-.112l-.45 6a.75.75 0 0 0 1.496.112Z"
    />
  </svg>
)
export default SvgTrashHover
